var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNotesx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon / ic_notes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M10.1087 0H4.242C2.114 0 0.875 1.246 0.875 3.381V10.612C0.875 12.782 2.114 14 4.242 14H10.1087C12.271 14 13.475 12.782 13.475 10.612V3.381C13.475 1.246 12.271 0 10.1087 0Z",
    fill: "#484848",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43127 3.25488V3.26188C4.12957 3.26188 3.88527 3.50688 3.88527 3.80788C3.88527 4.10888 4.12957 4.35388 4.43127 4.35388H6.52357C6.82527 4.35388 7.07027 4.10888 7.07027 3.80018C7.07027 3.49988 6.82527 3.25488 6.52357 3.25488H4.43127ZM9.91927 7.51788H4.43127C4.12957 7.51788 3.88527 7.27288 3.88527 6.97188C3.88527 6.67088 4.12957 6.42518 4.43127 6.42518H9.91927C10.2203 6.42518 10.4653 6.67088 10.4653 6.97188C10.4653 7.27288 10.2203 7.51788 9.91927 7.51788ZM9.91927 10.7169H4.43127C4.22127 10.7449 4.01827 10.6399 3.90627 10.4649C3.79427 10.2829 3.79427 10.0519 3.90627 9.87688C4.01827 9.69488 4.22127 9.59688 4.43127 9.61788H9.91927C10.1986 9.64588 10.4093 9.88388 10.4093 10.1709C10.4093 10.4502 10.1986 10.6889 9.91927 10.7169Z",
    fill: "#484848",
    fillOpacity: 0.8
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotesx);
export default __webpack_public_path__ + "static/media/ic_notesx.4d2f6532cdb5ca1d073a961620562c10.svg";
export { ForwardRef as ReactComponent };